module.exports = __webpack_public_path__ + "img/offers.05c0172c.svg";